<template>
<modal @close="onModalClose" :no-footer="true">
    <template slot="header">
        Setup SiteLink Tenants for Insurance
    </template>

    <template slot="content">
        <div>Setting up {{ tenants.length }} tenants.</div>

        <div v-if="tenants.length > 1">
            <progress max="100" :value="percent_complete" />
        </div>

        <hr class="small" />

        <div v-for="(tenant, index) in tenant_window" :key="`setup-tenant-${index}`" class="tenant-item flex ai-c jc-sb mt-4">
            <div class="flex-0">
                <span class="badge gray" v-if="tenant.setup_status === 'idle'" title="Idle">
                    <span class="material-icons">hourglass_empty</span>
                </span>

                <span class="badge secondary" v-else-if="tenant.setup_status === 'loading'" title="Loading">
                    <span class="material-icons">more_horiz</span>
                </span>

                <span class="badge danger" v-else-if="tenant.setup_status === 'error'" title="Error">
                    <span class="material-icons">report_problem</span>
                </span>

                <span class="badge primary" v-else-if="tenant.setup_status === 'complete'" title="Complete">
                    <span class="material-icons">done</span>
                </span>

                <span class="badge warning" v-else-if="tenant.setup_status === 'ignoring'" title="Ignoring">
                    <span class="material-icons">hourglass_disabled</span>
                </span>

                <span class="badge warning" v-else>?</span>
            </div>

            <div class="flex-a ml-3">
                {{ tenant.unit }} - {{ tenant.full_name }}
            </div>
        </div>

        <div v-if="errors.length !== 0" class="mt-3">
            <hr  class="small" />

            <div class="mb-3">Experienced {{ errors.length }} errors:</div>

            <div v-for="(error, index) in errors" :key="`setup-error-${index}`" class="error-item flex ai-c jc-sb">
                <div class="flex-0 ws-nw">
                    {{ error.tenant.unit }} - {{ error.tenant.full_name }}
                </div>

                <div class="flex-a danger-text ml-3">
                    {{ error.message }}
                </div>
            </div>
        </div>

        <div v-if="current_tenant_index === tenants.length - 1" class="mt-3">
            <hr class="small" />

            ✨ <strong>Setup complete!</strong> Please remember to click the <strong>Check Charges</strong> button after exiting this pop&ndash;up!
        </div>
    </template>
</modal>
</template>

<script>
import http from "@/http"
import Vue from "vue"
import { wait } from "@/utilities/misc"

export default {
    name: "setup-tenants-modal",

    props: {
        tenants: {
            required: true,
            type: Array
        }
    },

    data () {
        return {
            consecutive_errors: 0,
            current_tenant_index: 0,
            errors: [],
            formatted_tenants: this.tenants.map((tenant) => {
                let fullName = ""

                if (tenant.last_name === null) {
                    fullName = tenant.first_name
                } else {
                    fullName = `${tenant.last_name}, ${tenant.first_name}`
                }

                return Object.assign({
                    full_name: fullName,
                    setup_status: "idle"
                }, tenant)
            })
        }
    },

    computed: {
        percent_complete () {
            const quotient = this.current_tenant_index / Math.max(1, (this.tenants.length - 1))

            return parseInt(quotient * 100)
        },

        tenant_window () {
            if (this.tenants.length <= 10) {
                return this.formatted_tenants
            }

            let start = this.current_tenant_index - 5
            let end = this.current_tenant_index + 5 + 1

            if (end > (this.tenants.length - 1)) {
                start -= (end - this.tenants.length)
            }

            if (start < 0) {
                end += (0 - start)
            }

            return this.formatted_tenants.slice(Math.max(0, start), Math.min(this.tenants.length, end))
        }
    },

    mounted () {
        Vue.nextTick(async () => {
            await wait(250)

            for (const index in this.formatted_tenants) {
                this.current_tenant_index = parseInt(index)
                this.formatted_tenants[index].setup_status = "loading"

                try {
                    if (this.consecutive_errors >= 3) {
                        this.formatted_tenants[index].setup_status = "ignoring"
                    } else {
                        const params = new URLSearchParams()
                        params.append("tenant_id", this.formatted_tenants[index].id)

                        await http.post("/api/tenants/setup-policy", params)

                        this.consecutive_errors = 0
                        this.formatted_tenants[index].setup_status = "complete"
                    }
                } catch (ex) {
                    this.consecutive_errors += 1
                    this.formatted_tenants[index].setup_status = "error"

                    if (ex.message) {
                        this.errors.push({ tenant: this.formatted_tenants[index], message: ex.message })
                    } else if (typeof ex === "string") {
                        this.errors.push({ tenant: this.formatted_tenants[index], message: ex })
                    } else {
                        console.error(ex)
                        this.errors.push({ tenant: this.formatted_tenants[index], message: "Got unexpected response from server" })
                    }
                }
            }
        })
    },

    methods: {
        onModalClose () {
            if (!this.is_saving) {
                this.$emit("close")
            }
        }
    }
}
</script>

<style scoped>
.tenant-item {
    line-height: 1;
    white-space: nowrap;
    text-overflow: ellipsis;
}

.tenant-item + .tenant-item {
    margin-top: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/insurance-policy-management-page/SetupSiteLinkTenantsModal.vue